import React from "react";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";
import IntlMessages from "../../../../util/IntlMessages";
import MyBoardsSettings from "./MyBoardsSettings";

const MyBoardsSettingsModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.widgetSettings" />} key="2">
            <MyBoardsSettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default MyBoardsSettingsModal;
